import { useState } from "react";
import dropdownIcon from "../../../../../src/assets/images/dropdown-icon.svg";

const QuestionSection = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqData = [
    {
      question: "What exactly does the app do?",
      answer:
        "DOXBOX helps you store all your important documents, like passports, IDs, bank details, and certificates, in one safe and organized place on your phone. You can access them anytime, share them when needed, and never worry about losing papers again. It’s built with strong security but made simple enough for anyone to use.",
    },
    {
      question: "Is my data safe and private?",
      answer:
        "Absolutely. Your data is encrypted, securely stored, and fully under your control. Nothing is ever shared unless you choose to share it, and your information is never sold or exposed to any third parties.",
    },
    {
      question: "Can I use the app for my whole family?",
      answer:
        "Yes. DOXBOX is built to support your entire household, including your spouse, children, extended family members, and even pets. You can store and manage documents like IDs, passports, CVs, marriage certificates, vaccination cards, and more, all in one secure place.",
    },
    {
      question: "What happens if I lose my phone?",
      answer:
        "No problem! Your documents are safely stored in the cloud. Just log in from any other device with your credentials, and everything will be right there, exactly as you left it.",
    },
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <section className="bg-light-blue d-flex align-items-center">
      <div className="container">
        <div className="row g-5 align-items-center">
          {/* Left Text */}
          <div className="col-12 col-md-6 d-flex flex-column justify-content-center text-center text-md-start">
            <h2 className="fs-56 mb-3 mb-md-4">Got Questions?</h2>
            <p className="fs-5 text-muted lh-2_2">
              Wondering how DOXBOX works? These quick answers cover what most
              people want to know.
            </p>
          </div>

          {/* Right Accordion */}
          <div className="col-12 col-md-6 right-accord">
            <div className="accordion" id="faqAccordion">
              {faqData.map((item, index) => (
                <div
                  className="accordion-item border-0 bg-white rounded-3 mb-3"
                  key={index}
                >
                  <h2 className="accordion-header">
                    <button
                      className={`accordion-button bg-white shadow-sm d-flex justify-content-between align-items-center ${activeIndex === index ? "" : "collapsed"
                        }`}
                      onClick={() => toggleAccordion(index)}
                      type="button"
                    >
                      <span className="fw-semibold text-dark">
                        {item.question}
                      </span>
                      <span className="badge bg-crimson rounded d-flex justify-content-center align-items-center p-2 ms-3">
                        <img
                          src={dropdownIcon}
                          alt="Toggle"
                          className={`dropdown-icon ${activeIndex === index ? "rotate" : ""
                            }`}
                        />
                      </span>
                    </button>
                  </h2>
                  <div
                    className={`accordion-collapse collapse ${activeIndex === index ? "show" : ""
                      }`}
                  >
                    <div className="accordion-body text-muted fs-6">
                      {item.answer}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default QuestionSection;
